import React from 'react';
import { Check, Clock, Zap } from 'lucide-react';
import { useCountdown } from '../hooks/useCountdown';
export function PricingSection() {
  const {
    minutes,
    seconds
  } = useCountdown(13, 11);
  const handleCheckout = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    // Track the InitiateCheckout event
    if (window.fbq) {
      window.fbq('track', 'InitiateCheckout', {
        content_name: 'MegaPack Mecánica Preventiva',
        content_category: 'Digital Product',
        value: 19990,
        currency: 'ARS'
      });
    }
    // Smooth delay before redirect
    setTimeout(() => {
      window.location.href = 'https://checkout.recursospro.shop/cart/47636218675456:1';
    }, 300);
  };
  return <section className="bg-gradient-to-b from-gray-100 to-white py-16 px-4" id="pricing" data-id="element-99">
      <div className="max-w-3xl mx-auto" data-id="element-100">
        {/* Big Title */}
        <div className="text-center mb-8" data-id="element-101">
          <div className="inline-flex items-center gap-2 bg-red-600 text-white px-4 py-2 rounded-full text-sm font-bold mb-4 animate-pulse" data-id="element-102">
            <Clock className="w-4 h-4" data-id="element-103" />
            OFERTA TERMINA EN: {minutes}:{seconds}
          </div>
          <h2 className="text-4xl md:text-6xl font-black text-gray-900 mb-2" data-id="element-104">
            🔥 OFERTA POR TIEMPO LIMITADO
          </h2>
          <p className="text-xl text-gray-600" data-id="element-105">
            ¡Aprovechá este precio especial antes de que termine!
          </p>
        </div>

        <div className="bg-white rounded-3xl shadow-2xl border-4 border-green-500 overflow-hidden" data-id="element-106">
          <div className="bg-green-500 p-4 text-center" data-id="element-107">
            <h3 className="text-xl md:text-2xl font-black text-white uppercase tracking-wide flex items-center justify-center gap-2" data-id="element-108">
              <Zap className="w-6 h-6" data-id="element-109" />
              📦 Lo que recibís hoy
              <Zap className="w-6 h-6" data-id="element-110" />
            </h3>
          </div>

          <div className="p-8 md:p-12" data-id="element-111">
            <ul className="space-y-4 mb-8" data-id="element-112">
              {['6 Tomos de Mecánica Preventiva', 'Bono #1: Mini-Curso de Mantenimiento', 'Bono #2: Guía de Ruidos y Fallas', 'Bono #3: Registro de Mantenimiento', 'Acceso inmediato', 'Descarga digital', 'Acceso de por vida'].map((item, i) => <li key={i} className="flex items-center gap-3 text-lg md:text-xl text-gray-800 border-b border-gray-100 pb-2 last:border-0" data-id="element-113">
                  <div className="bg-green-100 p-1 rounded-full" data-id="element-114">
                    <Check className="w-5 h-5 text-green-600" data-id="element-115" />
                  </div>
                  {item}
                </li>)}
            </ul>

            <div className="text-center mb-8 bg-gradient-to-r from-red-50 to-orange-50 p-6 rounded-xl border-2 border-red-200" data-id="element-116">
              <p className="text-gray-500 text-lg mb-2" data-id="element-117">
                Precio regular:{' '}
                <span className="line-through decoration-red-500 decoration-4 text-red-400 font-bold text-2xl" data-id="element-118">
                  ARS $49.990
                </span>
              </p>
              <div className="flex flex-col items-center justify-center gap-2" data-id="element-119">
                <span className="text-red-600 font-bold text-2xl uppercase" data-id="element-120">
                  🔥 HOY SOLO:
                </span>
                <span className="text-5xl md:text-7xl font-black text-green-600 tracking-tight" data-id="element-121">
                  ARS $19,990
                </span>
                <span className="text-green-700 font-semibold text-lg" data-id="element-122">
                  ¡Ahorrás $30.000!
                </span>
              </div>
            </div>

            <a href="https://checkout.recursospro.shop/cart/47636218675456:1" onClick={handleCheckout} className="block w-full text-center bg-gradient-to-b from-green-500 to-green-600 hover:from-green-400 hover:to-green-500 text-white font-bold text-xl md:text-2xl py-5 md:py-6 rounded-lg shadow-xl border-b-4 border-green-700 transition-all duration-300 transform active:scale-95 hover:scale-105" data-id="element-123">
              👉 OBTENER MI MEGAPACK HOY
            </a>

            <p className="text-center text-gray-500 mt-4 text-sm" data-id="element-124">
              ✅ Pago único · ✅ Acceso inmediato · ✅ Garantía de 7 días
            </p>
          </div>
        </div>

        {/* Guarantee Badge */}
        <div className="mt-12 text-center max-w-2xl mx-auto bg-white p-8 rounded-2xl shadow-lg border border-gray-200" data-id="element-125">
          <div className="inline-block p-3 bg-green-100 rounded-full mb-4" data-id="element-126">
            <span className="text-5xl" data-id="element-127">🔒</span>
          </div>
          <h3 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-128">
            Garantía sin riesgo de 7 días
          </h3>
          <p className="text-gray-600" data-id="element-129">
            Probalo durante 7 días. Si no te da claridad, control y tranquilidad
            al cuidar tu vehículo,
            <span className="font-bold text-gray-900" data-id="element-130">
              {' '}
              te devolvemos el 100% del dinero.
            </span>{' '}
            Sin preguntas.
          </p>
        </div>
      </div>
    </section>;
}